module.exports = {"632524100":"子科滩镇","632524101":"河卡镇","632524102":"曲什安镇","632524200":"温泉乡","632524201":"龙藏乡","632524202":"中铁乡","632524203":"唐乃亥乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/632524.json
// module id = 3144
// module chunks = 0